import { useContext } from "react";

import { ParticipantViewsContext } from "./ParticipantViewsContext";

export function useParticipantViews() {
  const context = useContext(ParticipantViewsContext);
  if (!context) {
    throw new Error("useParticipantViews must be used within a ParticipantViewsProvider");
  }
  return context;
}
